module.exports = __webpack_public_path__ + "f4959c21780b730281caab6ae5d4c0c1.pdf";